import { FC, ReactNode } from 'react'

export const PageHeader: FC<{ title: ReactNode; className?: string }> = ({
  title,
  className,
}) => {
  return (
    <h1
      className={`
        font-recoleta font-semibold
        leading-[140%]
        text-3xl
        block
        mb-10
        ${className}
        `}
    >
      {title}
    </h1>
  )
}
